import eng from "../messages/english.js";

const languages = {
  eng,
};

const getMessage = (module, key, language = "eng", ...args) => {
  let message = languages[language]?.[module]?.[key];
  if (!message) {
    message = "Oops something went wrong!";
  }
  return typeof message === "function" ? message(...args) : message;
};

export default getMessage;
